import { Home, Wallet, ClipboardList, Target, Handshake } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { AccordionList } from "../components/AccordionList";
import { AUDIENCE_CARDS, ROADMAP, MODULES, WEBINAR, scrollToId } from "../lib/content";

const ICONS = { Home, Wallet, ClipboardList, Target, Handshake };

export const Audience = () => (
  <section id="learn" className="py-28 md:py-36 px-6 md:px-12" style={{ background: "#F2EEFB" }} data-testid="audience-section">
    <div className="max-w-[1440px] mx-auto">
    <Reveal>
      <p className="chapter-label mb-6">[003] — WHO THIS IS FOR</p>
      <h2 className="font-display font-bold uppercase text-3xl md:text-5xl tracking-tight mb-14">This Training Is Designed For:</h2>
    </Reveal>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {AUDIENCE_CARDS.map((card, i) => {
        const Icon = ICONS[card.icon];
        return (
          <Reveal key={i} delay={i * 0.06}>
            <div
              className="group p-7 h-full border border-black/10 transition-[border-color,background-color,transform] duration-300 hover:scale-[1.02]"
              style={{ background: "rgba(0,0,0,0.02)" }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7C3AED"; e.currentTarget.style.background = "rgba(124,58,237,0.08)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(0,0,0,0.1)"; e.currentTarget.style.background = "rgba(0,0,0,0.02)"; }}
              data-testid={`audience-card-${i}`}
            >
              <Icon size={24} className="mb-5" style={{ color: "#7C3AED" }} />
              <p className="font-display font-semibold text-lg leading-snug text-[#181818]">{card.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
    <Reveal delay={0.15}>
      <button onClick={() => scrollToId("register")} className="btn-accent mt-12 px-8 py-4 text-[13px]" data-testid="audience-cta">
        ✓ RESERVE MY FREE SEAT
      </button>
    </Reveal>
    </div>
  </section>
);

export const Roadmap = () => (
  <section className="border-y border-black/10" style={{ background: "#FFFFFF" }} data-testid="roadmap-section">
    <div className="max-w-[1440px] mx-auto grid grid-cols-2 lg:grid-cols-4">
      {ROADMAP.map((step, i) => (
        <div key={step.step} className={`group relative p-8 md:p-12 overflow-hidden ${i > 0 ? "border-l border-black/10" : ""} ${i > 1 ? "border-t lg:border-t-0 border-black/10" : ""}`} data-testid={`roadmap-step-${i}`}>
          <span className="absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full transition-[width] duration-500 ease-out" style={{ background: "#7C3AED" }} />
          <span className="absolute -top-4 -right-2 font-mono-c font-bold text-[120px] leading-none text-black/[0.04] select-none">{step.step}</span>
          <Reveal delay={i * 0.08}>
            <p className="font-mono-c text-[10px] tracking-[0.3em] mb-3" style={{ color: "#6D28D9" }}>STEP {step.step}</p>
            <h3 className="font-display font-bold uppercase text-xl mb-3">{step.name}</h3>
            <p className="text-[13px] leading-relaxed text-black/45">{step.desc}</p>
          </Reveal>
        </div>
      ))}
    </div>
  </section>
);

export const Curriculum = () => (
  <section className="py-28 md:py-36 px-6 md:px-12" style={{ background: "#F2EEFB" }} data-testid="curriculum-section">
    <div className="max-w-[1100px] mx-auto">
    <Reveal>
      <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
        <div>
          <p className="chapter-label mb-6">[004] — THE CURRICULUM</p>
          <h2 className="font-display font-bold uppercase text-3xl md:text-5xl tracking-tight">Get a Sneak Peek Into the Webinar</h2>
        </div>
        <p className="font-mono-c text-[11px] tracking-[0.2em] text-black/40">{WEBINAR.moduleCount} MODULES · {WEBINAR.duration} TOTAL</p>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <AccordionList items={MODULES.map((m) => ({ title: m.title, body: m.body }))} testPrefix="curriculum" />
    </Reveal>
    </div>
  </section>
);
